import { SVGProps } from 'react'

export const CameraOffWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33301 3.33301C2.22844 3.33301 1.33301 4.22844 1.33301 5.33301V10.6663C1.33301 11.7709 2.22844 12.6663 3.33301 12.6663H9.33301C10.2348 12.6663 10.9972 12.0695 11.2467 11.2493M11.333 7.99967L13.7559 5.5768C14.0415 5.29121 14.1843 5.14842 14.3069 5.13877C14.4132 5.1304 14.5172 5.17346 14.5865 5.2546C14.6663 5.34811 14.6663 5.55004 14.6663 5.95392V10.0454C14.6663 10.4493 14.6663 10.6512 14.5865 10.7448C14.5172 10.8259 14.4132 10.8689 14.3069 10.8606C14.1843 10.8509 14.0415 10.7081 13.7559 10.4226L11.333 7.99967ZM11.333 7.99967V6.53301C11.333 5.4129 11.333 4.85285 11.115 4.42503C10.9233 4.0487 10.6173 3.74274 10.241 3.55099C9.81317 3.33301 9.25311 3.33301 8.13301 3.33301H6.33301M1.33301 1.33301L14.6663 14.6663"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
